// client/src/config/config.js
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://192.168.178.147:5000'
};

export default config;